import { useState, useEffect } from "react";

import { useAppStore } from "@/store/appStore";
import { CHAT_TYPE } from "@/types/navigation-mode";

import { tabList } from "@/const/homeConst";
import Text from "@/components/text/text";
import { useExplorationStore } from "@/store/explorationStore";
// import VenueMap from "@/components/map/venue-map";
import GoogleMap from "@/components/map/google/google-map";
import GoogleMap2D from "@/components/map/google/google-map-2D";

export default function ExplorationPanel() {
  const chatType = useAppStore((state) => state.chatType);
  const [selectedTab, setSelectedTab] = useState(
    () => tabList.find((c) => c.type === CHAT_TYPE.EXPLORATION) || tabList[0]
  );
  const setChatType = useAppStore((state) => state.setChatType);
  const setShowExplorationPanel = useExplorationStore(
    (state) => state.setShowExplorationPanel
  );

  useEffect(() => {
    const currentTab = tabList.find((c) => c.type === chatType) || tabList[0];
    setSelectedTab(currentTab);
    setChatType(currentTab.type);
  }, [chatType]);

  const [expanded, setExpanded] = useState(false);
  const onSelect = (tab: any) => {
    setSelectedTab(tab);
    setChatType(tab.type);
    if (tab.type !== CHAT_TYPE.EXPLORATION) {
      setShowExplorationPanel(false);
    }
  };

  const tabs = () => {
    return (
      <div className="flex tabs justify-between mb-[5px] mt-[12px]">
        {tabList.map((tab) => {
          return (
            <div
              key={`tab-${tab.type}`}
              className="flex grow justify-center"
              onClick={() => {
                onSelect(tab);
              }}
            >
              <Text
                text={tab.name}
                className={`text-center w-full py-[8px] ${selectedTab.type === tab.type
                  ? `selected-tab`
                  : "disabled-text"
                  }`}
              />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className={`fixed left-0 right-0 mx-auto transition-all duration-300 ease-in-out
        shadow-2xl bottom-0  max-w-[100%] flex flex-col z-50 text-default leading-[22px]
        ${expanded ? "h-[100dvh]" : "h-[95dvh] gradient-border-top-outer "}
     `}
      style={{
        background: "linear-gradient(270deg, #04290C 0%, #022C30 100%)",
      }}
    >
      <div style={{ zIndex: 6 }}>
        {expanded ? null : tabs()}
        <div style={{ background: "black" }}>
          {/* <GoogleMap2D onZoomIn={() => setExpanded(true)} /> */}
          <GoogleMap onZoomIn={() => setExpanded(true)} />
          {/* <VenueMap onZoomIn={() => setExpanded(true)} isConstrained={false} /> */}
        </div>
      </div>
    </div>
  );
}
